/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
export default [
    'cueVideoById',
    'loadVideoById',
    'cueVideoByUrl',
    'loadVideoByUrl',
    'playVideo',
    'pauseVideo',
    'stopVideo',
    'clearVideo',
    'getVideoBytesLoaded',
    'getVideoBytesTotal',
    'getVideoLoadedFraction',
    'getVideoStartBytes',
    'cuePlaylist',
    'loadPlaylist',
    'nextVideo',
    'previousVideo',
    'playVideoAt',
    'setShuffle',
    'setLoop',
    'getPlaylist',
    'getPlaylistIndex',
    'getPlaylistId',
    'loadModule',
    'unloadModule',
    'setOption',
    'mute',
    'unMute',
    'isMuted',
    'setVolume',
    'getVolume',
    'seekTo',
    'getPlayerState',
    'getPlaybackRate',
    'setPlaybackRate',
    'getAvailablePlaybackRates',
    'getPlaybackQuality',
    'setPlaybackQuality',
    'getAvailableQualityLevels',
    'getCurrentTime',
    'getDuration',
    'removeEventListener',
    'getVideoUrl',
    'getDebugText',
    'getVideoData',
    'addCueRange',
    'removeCueRange',
    'getApiInterface',
    'showVideoInfo',
    'hideVideoInfo',
    'G',
    'C',
    'R',
    'aa',
    '$',
    'Z',
    'getVideoEmbedCode',
    'getOptions',
    'getOption',
    'Y',
    'X',
    'addEventListener',
    'destroy',
    'A',
    'P',
    'J',
    'setSize',
    'getIframe'
];
